import React from "react";
import { connect } from 'react-redux';
import PropTypes from "prop-types";

import '../../css/DriverQueue.css';

export const InternalDriverQueue = ({dock, depositBlockedDriverIds}) => {
  let driver = dock.driver;

  if (!driver || driver.state === 'plan') {
    return null;
  }
  let position = driver.queue_position;
  if(position === 0){
    position = '-';
  }

  const isBlockedByDeposit = depositBlockedDriverIds.includes(driver.id);

  let classes = "DriverQueue badge badge-pill badge-" + driver.vehicle.toLowerCase();
  if (isBlockedByDeposit) {
    classes = "DriverQueue badge badge-pill badge-blocked-deposit";
  }
  return <span className={classes} title={`Priorité livreur : ${position}`}>{position}</span>;
};

InternalDriverQueue.propTypes = {
  dock: PropTypes.object.isRequired,
  depositBlockedDriverIds: PropTypes.array,
};

export const DriverQueue = connect(
  (state) => {
    return {
      depositBlockedDriverIds: state.dispatch.deposit_blocked_driver_ids || [],
    };
  }
)(InternalDriverQueue);
